/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lg_Companion_NoteInputs */

const en_lg_companion_note = /** @type {(inputs: Lg_Companion_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The package is available for manual installation and has not been published in the Chrome Web Store. Testing with a real Google Calendar account is still pending; an unrecognized or changed editor cancels insertion.`)
};

const id_lg_companion_note = /** @type {(inputs: Lg_Companion_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paket tersedia untuk pemasangan manual, belum diterbitkan di Chrome Web Store. Pengujian dengan akun Google Calendar nyata belum selesai; editor yang tidak dikenali atau berubah membatalkan penyisipan.`)
};

/**
* | output |
* | --- |
* | "The package is available for manual installation and has not been published in the Chrome Web Store. Testing with a real Google Calendar account is still pen..." |
*
* @param {Lg_Companion_NoteInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const lg_companion_note = /** @type {((inputs?: Lg_Companion_NoteInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lg_Companion_NoteInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_lg_companion_note(inputs)
	return en_lg_companion_note(inputs)
});